<template>
  <div class="card">
    <div class="card-header flex-wrap pt-6 pb-0">
      <div class="card-title">
        <div class="card-label">
          <h3 class="card-label mb-2">{{ $t('events.planning.list') }}</h3>
        </div>
      </div>
      <div class="card-toolbar">
        <div class="d-flex">
          <div class="col-5 mt-3"><Button type="new" btn-class="btn-md" btn-text="events.planning.create" @click="openCreateView"></Button></div>
          <div class="col-7">
            <Input
                inputClass="form-control form-control-sm"
                name="input-search"
                :isInputGroup="true"
                :placeholder="$t('label.search')" 
                :action="loadDataForSearch"
                v-model="search"
            >
              <template #rightAddon>
                <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle me-3" @click="loadDataForSearch">
                <i class="fa fa-search"></i>
                </span>
              </template>
            </Input>
          </div>

        </div>
      </div>
    </div>
    <div v-if="isLoading" class="card-body">
      <div class="h-200px d-flex justify-content-center align-items-center">
        <div class="text-center">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">{{ $t("loadingText") }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="card-body">
      <!-- Toggle Public/Private -->
      <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
        <input type="radio" class="btn-check" name="btnradio" id="btnradio1" value="PUBLIC" v-model="query.publicStatus" checked>
        <label class="btn btn-primary bg-white bg-hover-primary bg-active-primary btn-text-primary text-hover-white text-active-white border-primary border" for="btnradio1">{{$t('events.planning.general')}}</label>

        <input type="radio" class="btn-check" name="btnradio" id="btnradio2" value="PRIVATE" v-model="query.publicStatus">
        <label class="btn btn-primary bg-white bg-hover-primary bg-active-primary btn-text-primary text-hover-white text-active-white border-primary border" for="btnradio2">{{$t('events.planning.salon')}}</label>
      </div>

      <!-- Public Planning -->
      <div v-if="query.publicStatus === 'PUBLIC'">
        <div v-if="plannings.public && Object.entries(plannings.public).length > 0" class="accordion accordion-icon-toggle" id="planning_accordion">
          <div v-for="([date, events], index) in Object.entries(plannings.public)" :key="date" class="mb-2">
            <div class="d-flex">
              <div class="accordion-header py-3 d-flex align-items-center" data-bs-toggle="collapse" :data-bs-target="'#planning_accordion_' + date">
            <span class="accordion-icon">
              <i class="fa fa-arrow-right"></i>
            </span>
                <h3 class="fs-4 fw-bold mb-0 ms-4">{{ date }}</h3>
              </div>
              <Button type="button" btn-class="btn-sm btn-icon btn-primary m-7" icon-class="fa fa-plus" @click.exact="openAddDayPlanView(date)" />
            </div>

            <div :id="'planning_accordion_' + date" class="fs-6 collapse ps-10" :class="{ show: index === 0 }" data-bs-parent="#planning_accordion">
              <PlanningRow
                  v-for="planning in events"
                  :key="planning.id"
                  :planning="planning"
                  :event-id="route.params.id"
                  @showQrcode="showQrcode"
                  @updatePlanning="updatePlanning"
                  @deletePlanning="deletePlanning"
              />
            </div>
          </div>
        </div>
        <div v-else>
          <div class="h-350px d-flex justify-content-center align-items-center" >
            <div class=" text-center ">
              <div class="pt-8 ">
                <Img filename="empty.png" alt=""
                     class="mw-100 h-125px h-sm-175px" />
              </div>
              <h2 class="fs-2x fw-bolder mb-0">{{ $t('no_data_found') }}</h2>
            </div>
          </div>
        </div>
      </div>

      <!-- Private Planning -->
      <div v-else>
        <div v-if="plannings.private && Object.entries(plannings.private).length > 0" class="accordion accordion-icon-toggle" id="planning_accordion">
          <div v-for="([date, events], index) in Object.entries(plannings.private)" :key="date" class="mb-2">
            <div class="d-flex">
              <div class="accordion-header py-3 d-flex align-items-center" data-bs-toggle="collapse" :data-bs-target="'#planning_accordion_' + date">
                <span class="accordion-icon">
                  <i class="fa fa-arrow-right"></i>
                </span>
                <h3 class="fs-4 fw-bold mb-0 ms-4">{{ date }}</h3>
              </div>
              <Button type="button" btn-class="btn-sm btn-icon btn-primary m-7" icon-class="fa fa-plus" @click.exact="openAddDayPlanView(date)" />
            </div>

            <div :id="'planning_accordion_' + date" class="fs-6 collapse ps-10" :class="{ show: index === 0 }" data-bs-parent="#planning_accordion">
              <PlanningRow
                  v-for="planning in events"
                  :key="planning.id"
                  :planning="planning"
                  :event-id="route.params.id"
                  @showQrcode="showQrcode"
                  @updatePlanning="updatePlanning"
                  @deletePlanning="deletePlanning"
              />
            </div>
          </div>
        </div>
        <div v-else>
          <div class="h-350px d-flex justify-content-center align-items-center" >
            <div class=" text-center ">
              <div class="pt-8 ">
                <Img filename="empty.png" alt=""
                     class="mw-100 h-125px h-sm-175px" />
              </div>
              <h2 class="fs-2x fw-bolder mb-0">{{ $t('no_data_found') }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <QrCodeModal id="workshop_qrcode_modal" :title="$t('events.planning.qrcode')" :to-encode="toEncode" name="join_workshop_qrcode" />
  <PlanningFormModal id="create_event_planning_modal" @load="loadData"/>
  <PlanningFormModal id="add_date_planning_modal" @load="loadData" :without-date="true" :custom-date="formDayPlanData.date"/>
  <PlanningFormModal id="edit_event_planning_modal" :edit="true" :form="formUpdate" @load="loadData"/>
</template>

<script setup>
import {computed, nextTick, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import {useLocales} from "@/composables/locales";
import {useSwal} from "@/composables/useSwal";
import i18n from "@/plugins/i18n";
import Button from "@/components/Button.vue";
import PlanningFormModal from "./modals/PlanningFormModal.vue";
import Input from "@/components/Input.vue"
import QrCodeModal from "../../components/Modal/QrCodeModal.vue";
import PlanningRow from "@/Modules/Events/views/Planning/components/PlanningRow.vue";
import Img from "@/components/Img.vue";

const router = useRouter()
const route = useRoute()
const store = useStore()
const {locale} = useLocales()

const {showSwal} = useSwal()

const isLoading = ref(true)

const query = ref({
  publicStatus: 'PUBLIC'
})

const formUpdate = ref({
    id: '',
    event_id: '',
    atelier: false,
    program: [
        {
            id: '',
            title: '',
            date: '',
            start_time: '',
            end_time: '',
            description: '',
            moderator_id: '',
            presentator_id: '',
            type_atelier: 'public',
            type_program: 'NONE'
        }
    ]
})

const formDayPlanData = ref({
  date: ''
})

const search = ref('')
const toEncode = ref('')
const planningData = ref({})

const plannings = computed(() => store.getters['planning/getPlannings'])

watch(() => locale.value, (value) => {
    nextTick(() => loadData())
}, { deep: true })

watch(() => route.query.tab, (value) => {
    if(value){
        loadData()
    }
})

watch(() => search.value, async(value) => {
    if (!value) {
        loadData()
    }
});

function deletePlanning(id) {
    showSwal(
        i18n.global.t('events.planning.swal_deleted'),
        i18n.global.t('events.planning.swal_deleted_text')
    ).then( async (result) => {
    if (result.value) {
        store.dispatch('planning/deletePlanning', {id: id, event_id: route.params.id})
        .then(() => {
            window.toastr['success'](i18n.global.t('events.planning.deleted_successfully'))
            loadData()
        })
        .catch(() => {

        })
    }
    })
}

function openCreateView() {
    $('#create_event_planning_modal').modal('toggle')
}

function openAddDayPlanView(dayDate) {
  formDayPlanData.value.date = dayDate
  $('#add_date_planning_modal').modal('toggle')
}

function showQrcode (url) {
    toEncode.value = url
    $('#workshop_qrcode_modal').modal('toggle')
}

function formatTime(time) {
    let times = time.split(':')
    return times[0] + ':' + times[1]
}

async function updatePlanning(id) {
    await store.dispatch('planning/getEventPlanning', {id: id, event_id: route.params.id}).then((res) => {
        let data = res.data.event_program
        if (!data) return;

        const date = data?.date;
        const [year, month, day] = date.split("-");
        const formattedDate = `${day}-${month}-${year}`;

        formUpdate.value.event_id = data?.model_id
        formUpdate.value.id = data?.id
        formUpdate.value.program = []
        formUpdate.value.atelier = data?.type_program == 'ATELIER' ? true : false

        let program = []
        program.push({
            id: data?.id,
            title: data?.title,
            date: formattedDate,
            start_time: formatTime(data?.start_time),
            end_time: formatTime(data?.end_time),
            description: data?.description ?? '',
            moderator_id: data?.moderator_id ?? '',
            presentator_id: data?.presentator_id ?? '',
            type_atelier: data?.type_atelier,
            type_program: data?.type_program ?? ''
        })
        formUpdate.value.program = program

        $('#edit_event_planning_modal').modal('toggle')
    })
}


function loadDataForSearch() {
    if(search.value) loadData()
}

function loadData() {
    if(route.query.tab === 'tab-planning'){
      isLoading.value = true
      store.dispatch('planning/loadPlannings', {id: route.params.id, search: search.value})
          .finally(() => isLoading.value = false)
    }
}

onMounted( () => {
    loadData()
})
</script>